import { render, staticRenderFns } from "./IsPayment.vue?vue&type=template&id=4e515868&"
import script from "./IsPayment.vue?vue&type=script&lang=js&"
export * from "./IsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports